<template>
  <van-tabbar route>
  <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
  <van-tabbar-item replace to="/index1" icon="description">话术库</van-tabbar-item>
  <van-tabbar-item replace to="/index2" icon="orders-o">知识库</van-tabbar-item>
</van-tabbar>
</template>
<script>
  export default {
  name: "tab",
  data() {
    return {
    
    };
  },
  created() {
  
  },
  methods: {
    
  },
};
</script>


// WEBPACK FOOTER //
// src/components/tab.vue